import React from 'react';
import { createGlobalStyle } from 'styled-components';

const BrightWorldGlobalStyle = createGlobalStyle`

  @font-face {
    font-family: 'CurrysSans';
    src: url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Regular.woff2') format('woff2'),
        url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Regular.woff') format('woff')
    }

  @font-face {
    font-family: 'CurrysSans';
    src: url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Oblique.woff2') format('woff2'),
        url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Oblique.woff') format('woff');
    font-style: italic;
  }
  @font-face {
    font-family: 'CurrysSans-LightOblique';
    src: url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-LightOblique.woff2') format('woff2'),
        url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-LightOblique.woff') format('woff')
  }
  @font-face {
    font-family: 'CurrysSans-Light';
    src: url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Light.woff2') format('woff2'),
        url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Light.woff') format('woff')
  }
  @font-face {
    font-family: 'CurrysSans';
    src: url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-HeadlineOblique.woff2') format('woff2'),
        url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-HeadlineOblique.woff') format('woff');
    font-weight: bold;
    font-style: italic;
  }
  @font-face {
    font-family: 'CurrysSans';
    src: url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Headline.woff2') format('woff2'),
        url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Headline.woff') format('woff');
    font-weight: bold;
  }

  body {
    font-family: 'CurrysSans', Helvetica, Arial, sans-serif;

    a {
      color: ${(props) => props.theme.colors.primary.purple};
      text-decoration: none;

      &:hover {
        color: ${(props) => props.theme.colors.primary.purpleHover};
      }
    }
  }
`;


export const BrightWorldGlobalFonts = () => <BrightWorldGlobalStyle />;
